<template>
    <div class="cart-conflict-modal-wrapper">
        <div
            class="modal fade"
            id="cart-conflict-warning-modal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="cartConflictLabel"
            aria-hidden="true"
        >
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="cartConflictLabel">
                            <slot name="title">Item Already in Cart</slot>
                        </h5>
                        <button
                            type="button"
                            class="close"
                            @click="handleCancel"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <slot name="message">
                            <div class="conflict-message">
                                <p>
                                    <strong>{{ productName }}</strong> with
                                    <strong>{{ colorName }}</strong> color and
                                    <strong>{{ serviceName }}</strong> service is
                                    already in your cart.
                                </p>
                                <p>
                                    If you update the design, the cart item will
                                    be updated.
                                </p>
                            </div>
                        </slot>
                    </div>
                    <div class="modal-footer">
                        <slot name="actions">
                            <button
                                type="button"
                                class="btn btn-secondary"
                                @click="handleCancel"
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                class="btn btn-primary"
                                @click="handleProceed"
                            >
                                Proceed
                            </button>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CartConflictWarningModal",
    props: {
        show: {
            type: Boolean,
            default: false,
            required: true
        },
        cartItem: {
            type: Object,
            default: () => ({}),
            required: false
        },
        productName: {
            type: String,
            default: "Product",
            required: false
        },
        colorName: {
            type: String,
            default: "Color",
            required: false
        },
        serviceName: {
            type: String,
            default: "Service",
            required: false
        }
    },
    data() {
        return {};
    },
    watch: {
        show(newVal) {
            /* eslint-disable */
            if (newVal) {
                $("#cart-conflict-warning-modal").modal("show");
            } else {
                $("#cart-conflict-warning-modal").modal("hide");
            }
            /* eslint-enable */
        }
    },
    methods: {
        handleCancel() {
            this.$emit("cancel");
            /* eslint-disable */
            $("#cart-conflict-warning-modal").modal("hide");
            /* eslint-enable */
        },
        handleProceed() {
            this.$emit("proceed");
            /* eslint-disable */
            $("#cart-conflict-warning-modal").modal("hide");
            /* eslint-enable */
        }
    }
};
</script>

<style scoped>
.cart-conflict-modal-wrapper {
    /* Wrapper for styling consistency */
}

.modal-header {
    border-bottom: 1px solid #dee2e6;
    padding: 1.5rem;
}

.modal-body {
    padding: 1.5rem;
}

.conflict-message {
    line-height: 1.6;
    color: #333;
}

.conflict-message p {
    margin-bottom: 1rem;
}

.conflict-message p:last-child {
    margin-bottom: 0;
}

.modal-footer {
    border-top: 1px solid #dee2e6;
    padding: 1rem;
    display: flex;
    gap: 10px;
    justify-content: flex-end;
}

.btn-secondary {
    background-color: #6c757d;
    border-color: #6c757d;
    color: #fff;
}

.btn-secondary:hover {
    background-color: #5a6268;
    border-color: #545b62;
}

.btn-primary {
    background-color: #1d6cb5;
    border-color: #1d6cb5;
    color: #fff;
}

.btn-primary:hover {
    background-color: #145895;
    border-color: #0f4478;
}
</style>
